import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpPlus } from 'src/app/SayTS/http-plus';
import { SharedService } from 'src/app/_shared/shared.service';
import { Fce } from 'src/app/SayTS/fce';

@Component({
  selector: 'app-admin-client',
  templateUrl: './admin-client.component.html',
  styleUrls: ['./admin-client.component.scss']
})
export class AdminClientComponent implements OnInit {
  client: any = null;
  users: any[] = [];
  isNew = false;
  disabled = false;

  constructor(
    private http: HttpPlus,
    private route: ActivatedRoute,
    private router: Router,
    public shared: SharedService
  ) {}

  async ngOnInit(): Promise<void> {
    this.disabled = !this.shared.rights?.r_edit;
    const id = this.route.snapshot.params.id_client;

    // Pokud není id, jedná se o nového klienta (route /admin/clients/new)
    if (!id) {
      this.isNew = true;
      this.client = {
        name: '',
        ico: '',
        dic: '',
        email: '',
        web: '',
        street: '',
        city: '',
        zip: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        notes: ''
      };
    } else {
      await this.loadClient(id);
    }
  }

  async loadClient(id: number): Promise<void> {
    try {
      const response: any = await this.http.get(`clients/get/${id}`);
      if (response) {
        this.client = response;
        this.users = response.users || [];
      }
    } catch (error) {
      this.shared.reportError(error, 'Error loading client');
      this.shared.error('Nepodařilo se načíst klienta');
    }
  }

  /** Otevře vytvoření nového uživatele s předvyplněným id_client. */
  addUser(): void {
    if (!this.client?.id_client) return;
    this.router.navigate(['/admin/users/new'], { queryParams: { id_client: this.client.id_client } });
  }

  openUser(idUser: number): void {
    this.router.navigate(['/admin/users', idUser]);
  }

  async save(): Promise<void> {
    try {
      const params = Fce.convertForServer(Fce.copy(this.client, true));
      const response: any = await this.http.post('clients/save', params);

      if (response) {
        this.shared.success('Klient uložen');
        if (this.isNew && response.id_client) {
          this.router.navigate(['/admin/clients', response.id_client], { replaceUrl: true });
        } else {
          this.router.navigate(['/admin/clients']);
        }
      }
    } catch (error) {
      this.shared.reportError(error, 'Error saving client');
      this.shared.error('Nepodařilo se uložit klienta');
    }
  }

  async delete(): Promise<void> {
    if (await this.shared.confirm('Opravdu smazat tohoto klienta?')) {
      try {
        const response: any = await this.http.delete(`clients/delete/${this.client.id_client}`);
        if (response) {
          this.shared.warning('Klient smazán');
          this.router.navigate(['/admin/clients']);
        }
      } catch (error) {
        this.shared.reportError(error, 'Error deleting client');
        this.shared.error('Nepodařilo se smazat klienta');
      }
    }
  }

  goBack(): void {
    this.router.navigate(['/admin/clients']);
  }
}
